import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './components/toast/toast.component';
import { InstallPromptComponent } from './components/pwa/install-prompt/install-prompt.component';
import { InstallGuideModalComponent } from './components/pwa/install-guide-modal/install-guide-modal.component';
import { ContextualHelpModalComponent } from './components/contextual-help-modal/contextual-help-modal.component';
import { SupportModalComponent } from './components/support-modal/support-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastComponent,
    InstallPromptComponent,
    InstallGuideModalComponent,
    ContextualHelpModalComponent,
    SupportModalComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {}
